import React from 'react';

interface WarningProps {
  label: string;
  children: React.ReactNode;
}

const Warning: React.FC<WarningProps> = ({ label, children }) => (
  <div className="bg-warning border border-warning-border border-l-[3px] border-l-warning-accent rounded-[6px] px-[16px] py-[12px] my-[10px] text-[13px] text-warning-text leading-[1.6]">
    <span className="font-bold mr-[6px]">{label}</span>
    {children}
  </div>
);

export default Warning;
